<mat-form-field [attr.data-form-field]="field" [appearance]="appearance" [formGroup]="formGroup" class="full-width">
  @if (icon) {
    <mat-icon matPrefix>{{ icon }}</mat-icon>
  }
  @if (label) {
    <mat-label class="label">{{ label | translate }}</mat-label>
  }

  @if (!multiline) {
    @if (!displayFn) {
      <input
        matInput
        [formControlName]="field"
        [maxlength]="maxLength"
        [type]="type"
        [readonly]="readonly"
        [required]="mandatory"
        [attr.minlength]="minLength"
        [attr.min]="minValue"
        [attr.max]="maxValue"
        [id]="field + '-input'"
        (keydown.enter)="keydownEnter($event)"
        (keydown.escape)="keydownEscape($event)"
        [appFocusAndSelect]="focusAndSelect"
        />
    } @else {
      <input [formControlName]="field" type="hidden" />
      <input
        matInput
        [disabled]="true"
        [readonly]="readonly"
        [value]="displayFn(formGroup.controls[field].value)"
        [type]="type"
        [attr.minlength]="minLength"
        [id]="field + '-input'"
        (keydown.enter)="keydownEnter($event)"
        (keydown.escape)="keydownEscape($event)"
        [appFocusAndSelect]="focusAndSelect"
        />
    }
  } @else {
    <textarea matInput [formControlName]="field" [maxlength]="maxLength" wrap="soft" cdkTextareaAutosize style="max-height: 200px" [id]="field + '-input'"></textarea>
  }


  @if (formGroup.controls[field].pending) {
    <button matSuffix mat-icon-button tabindex="1000">
      <app-loader [formField]="true"></app-loader>
    </button>
  }
  @if (shouldDisplayClearBtn()) {
    <button mat-icon-button matSuffix data-role="clear" (click)="resetControlValue($event)">
      <mat-icon>clear</mat-icon>
    </button>
  }
  @if (suffixButtonIcon) {
    <button mat-icon-button matSuffix data-role="suffix-btn" [disabled]="suffixButtonAction === null" (click)="suffixButtonAction()">
      <mat-icon>{{ suffixButtonIcon }}</mat-icon>
    </button>
  }
  <span matSuffix>
    <ng-content></ng-content>
  </span>

  <!-- The mat-error tag HAS to be directly inside the mat-form-field otherwise it doesn't render properly if inside the ng-container -->
  <mat-error>
    @for (e of displayedErrors(); track e) {
      <span [attr.data-form-field-error]="e.error">
        {{ e.messageKey | translate: formGroup.controls[field].getError(e.error) }}
      </span>
    }
  </mat-error>
  @if (hint) {
    <mat-hint>{{ hint }}</mat-hint>
  }
</mat-form-field>
